// Add this to your theme.js or create a new file
document.addEventListener('DOMContentLoaded', function() {
  // Handle Buy Now button functionality
  const buyNowButtons = document.querySelectorAll('.buy-now-button');
  
  buyNowButtons.forEach(button => {
    button.addEventListener('click', function() {
      const url = this.dataset.url;
      // Get the quantity from the input
      const quantityInput = document.querySelector('.quantity-input');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      
      // Get the variant ID
      const variantId = document.querySelector('input[name="id"]').value;
      
      // Create the URL with quantity
      const checkoutUrl = url.replace(':1', `:${quantity}`);
      
      // Redirect to checkout
      window.location.href = checkoutUrl;
    });
  });
  
  // Handle quantity selector functionality
  const quantitySelectors = document.querySelectorAll('.quantity-selector');
  
  quantitySelectors.forEach(selector => {
    const minusButton = selector.querySelector('.quantity-minus');
    const plusButton = selector.querySelector('.quantity-plus');
    const input = selector.querySelector('.quantity-input');
    
    minusButton.addEventListener('click', function() {
      let value = parseInt(input.value, 10);
      value = Math.max(1, value - 1);
      input.value = value;
      input.dispatchEvent(new Event('change'));
    });
    
    plusButton.addEventListener('click', function() {
      let value = parseInt(input.value, 10);
      value += 1;
      input.value = value;
      input.dispatchEvent(new Event('change'));
    });
  });
});